import { useEffect, useState } from "react";
import { Reveal } from "../Reveal";
import { JProductCard } from "./JProductCard";
import { JProductSheet } from "./JProductSheet";
import { useCart } from "../../context/CartContext";
import { eur, scrollToId } from "../../lib/api";

export const JCatalog = ({ products }) => {
  const [open, setOpen] = useState(null);
  const singles = products.filter((p) => !p.kit);
  const pack = products.find((p) => p.id === "pack-jungle");
  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("producto");
    const hit = id && singles.find((p) => p.id === id);
    if (!hit) return undefined;
    setOpen(hit);
    const t = setTimeout(() => scrollToId("catalogo"), 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);
  return (
    <section id="catalogo" data-testid="catalog-section" className="relative py-24 md:py-36 overflow-hidden">
      <img src="/img/leaves-right.webp" alt="" aria-hidden="true" className="pointer-events-none absolute -right-40 -top-10 w-[420px] opacity-30 rotate-12" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
          <Reveal className="md:col-span-7">
            <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#8CD05A] mb-6">La gama · 6 fórmulas</p>
            <h2 className="font-serif-d font-black text-5xl md:text-7xl leading-[0.92] tracking-tight">
              Seis fórmulas.<br /><span className="italic font-semibold text-[#F2B441]">Una selva entera.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4 md:col-start-9">
            <p className="text-[#C9D6C2] leading-relaxed">
              Cada animal, una fase. Grow para crecer, A Bloom para arrancar la flor, B Bloom como base de floración, Bongo Bloom para estimular, PK para engordar y Compact para el remate final.
            </p>
            <p className="text-[#C9D6C2] text-xs mt-4 font-mono-d">Tarifa oficial · precios en euros.</p>
          </Reveal>
        </div>
        {products.length === 0 ? (
          <p data-testid="catalog-empty" className="text-[#C9D6C2]">El catálogo no está disponible en este momento.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {singles.map((p, i) => <JProductCard key={p.id} p={p} index={i} onOpen={setOpen} />)}
          </div>
        )}
        {pack && <PackBanner pack={pack} />}
      </div>
      <JProductSheet p={open} onClose={() => setOpen(null)} />
    </section>
  );
};

const PackBanner = ({ pack }) => {
  const { add } = useCart();
  return (
    <Reveal className="mt-6">
      <div data-testid="product-card-pack-jungle" className="grid lg:grid-cols-12 rounded-[10px] overflow-hidden label-frame bg-[#143823]">
        <div className="lg:col-span-8 relative aspect-[16/9] lg:aspect-auto lg:min-h-[400px] bg-[#0E2A1C]">
          <img src={pack.image} alt="Pack Jungle con las seis etiquetas" loading="lazy" className="absolute inset-0 w-full h-full object-contain" />
        </div>
        <div className="lg:col-span-4 p-7 md:p-10 flex flex-col justify-center gap-5">
          <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#8CD05A]">{pack.category}</p>
          <h3 className="font-label text-5xl leading-none text-label-gold">{pack.name}</h3>
          <p className="text-[#C9D6C2] text-sm leading-relaxed">{pack.desc}</p>
          <div className="flex items-center justify-between">
            <span data-testid="product-price-pack-jungle" className="font-serif-d font-black text-4xl">{eur(pack.price)}</span>
            <button data-testid="product-add-to-cart-pack-jungle" onClick={() => add(pack)}
              className="rounded-full bg-[#F2B441] text-[#0E2A1C] px-6 h-12 text-sm font-bold hover:bg-[#F6EEDC] transition-colors">Añadir pack</button>
          </div>
        </div>
      </div>
    </Reveal>
  );
};
